// 初期表示
export const PAGE_INIT = "corp/earning-forecast/PAGE_INIT";
// 表示条件変更
export const CONDITION_CHANGE = "corp/earning-forecast/CONDITION_CHANGE";
// セレクトボックス項目
export const OPTIONS_LOAD = "corp/earning-forecast/OPTIONS_LOAD";
export const SELECTED_OPTIONS_SET =
  "corp/earning-forecast/SET_SELECTED_OPTIONS";
